import { formatCallTypes } from "./formatCallTypes";
const array = ["I", "O", "M", "V", "R", "B", "A"];

const CallTypeToIcon = (arrayTipoChiamata) => {

    return array.map((ele, indexEle) => {

    const callTypeTitle = formatCallTypes(indexEle + 1);

    return arrayTipoChiamata.formattedValue.includes(indexEle + 1) ?
                  ( <div title={callTypeTitle} key={indexEle} style={{ color: "#1976d2", marginRight:"5px", fontWeight:"bold" }}> {ele} </div>) :
                  (<div title={callTypeTitle} key={indexEle}style={{ color: "grey", marginRight:"5px" }}>{array[indexEle]}</div> )
    })
}

export default CallTypeToIcon;